module.exports = __webpack_public_path__ + "img/pickaxe-silver.d2f9bab8.svg";